module.exports = __webpack_public_path__ + "static/award-getapp-550b8671eb0ba0e927f6efb66276417b.png";